import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon/Icon";
import X from "@insite/mobius/Icons/X";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// eslint-disable-next-line spire/fenced-imports
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import { getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { PageLinkModelCustom } from "@MasterBluePrint/Overrides/Widgets/Common/HeaderSignIn";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface GlobalAccountMenuStyles {
    menuWrapper?: GridContainerProps;
    buttonMenuWrapper?: GridItemProps;
    buttonMenuItems?: InjectableCss;
    headerMenuWrapper?: GridItemProps;
    redUnderline?: InjectableCss;
    greyUnderline?: InjectableCss;
    headerMenuItems?: GridContainerProps;
    menuItem?: GridItemProps;
    linkItem?: InjectableCss;
    userGreeting?: InjectableCss;
    firstName?: InjectableCss;
    hiGreeting?: InjectableCss;
    icon?: InjectableCss;
    activeIcon?: InjectableCss;
    menutriangle?: InjectableCss;
    titleMenuHeaderSpacedTypography?: TypographyPresentationProps;
    titleMenuHeaderTypography?: TypographyPresentationProps;
    signOutButton?: ButtonPresentationProps;
}

const mapStateToProps = (state: ApplicationState) => ({
    isPunchOutSession: getIsPunchOutSession(state),
});
const mapDispatchToProps = {
    signOut,
    cancelPunchOut,
};
interface GlobalAccountMenuState {
    firstName: string;
    myAccountPageLink: PageLinkModelCustom;
    linkGroups: string[];
    myAccountMapping: string;
}

interface OwnProps {
    setShow: Function;
    show: boolean;
}

type Props = OwnProps & GlobalAccountMenuState & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const GlobalAccountMenuStyles: GlobalAccountMenuStyles = {
    menuWrapper: {
        css: css`
            height: auto;
            width: 54.1875rem;
            top: 4.375rem;
            right: -21.875rem;
            z-index: 99;
            position: absolute;
            -webkit-box-shadow: 0px 0px 20px -2px rgba(1, 19, 64, .59);
            -moz-box-shadow: 0px 0px 20px -2px rgba(1, 19, 64, .59);
            box-shadow: 0px 0px 20px -2px rgba(1, 19, 64, .59);
        `,
    },
    buttonMenuWrapper: {
        css: css`
            height: 100%
            width: 14.9375rem;
            background-color: #ffffff;
           
        `,
    },
    buttonMenuItems: {
        css: css`
            margin: 1.25rem;
        `,
    },
    headerMenuWrapper: {
        css: css`
            height: 100%;
            width: 39.25rem;
            background-color: #f3f4f5;
        `,
    },
    headerMenuItems: {
        css: css`
            height: 9.5625rem;
            width: 35.75rem;
            margin: 1.5625rem;
            margin-left: 1.375rem;
            > div {
                justify-content: space-around;
            }
        `,
    },
    titleMenuHeaderTypography: {
        css: css`
            color: #c63527;
            font-family: "Roboto", sans-serif;
            font-weight: 500;
            font-size: .875rem;
            letter-spacing: .01rem;
            line-height: 1.4375rem;
            margin-bottom: 1rem;
        `,
        ellipsis: true,
        transform: "uppercase",
    },
    signOutButton: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            height: 2.5rem;
            width: 8.0625rem;
            border: 1px solid #002554;
            border-radius: .125rem;
            background-color: #ffffff;
            color: #002554;
            margin-top: 2.375rem;
            font-family: "Roboto", sans-serif;
            font-size: .9375rem;
            line-height: 1.3125rem;
            text-align: center;
            &:hover {
                border: 1px solid #2060ad;
                border-radius: .125rem;
                background-color: #2060ad;
                color: #ddecfe;
                font-family: "Roboto", sans-serif;
                font-size: .875rem;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 1.3125rem;
                text-align: center;
            }
        `,
    },
    redUnderline: {
        css: css`
            height: .1875rem;
            width: 1.25rem;
            background-color: #c63527;
            position: absolute;
            top: 2.6rem;
        `,
    },
    greyUnderline: {
        css: css`
            box-sizing: border-box;
            height: .0625rem;
            width: 11.1875rem;
            border: 1px solid rgba(194, 209, 217, .45);
        `,
    },
    menuItem: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    linkItem: {
        css: css`
            color: #002554;
            font-family: "Roboto", sans-serif;
            font-size: .875rem;
            letter-spacing: -.014rem;
            line-height: 2.1875rem;
            text-transform: capitalize;
        `,
    },
    userGreeting: {
        css: css`
            display: flex;
            flex-wrap: nowrap;
            color: #002554;
            font-family: "Roboto", sans-serif;
            font-size: 1.125rem;
            font-weight: 500;
            line-height: 1.3rem;
            text-transform: capitalize;
            position: relative;
        `,
    },
    firstName: {
        css: css`
            margin-left: 0;
            text-transform: capitalize;
            white-space: normal !important;
        `,
    },
    hiGreeting: {
        css: css`
            white-space: nowrap !important;
            min-width: 1.5rem;
        `,
    },
    icon: {
        css: css`
            color: #002554;
            &:hover {
                color: #ddecfe;
                font-family: "Roboto", sans-serif;
                font-size: .875rem;
                font-weight: bold;
            }
        `,
    },
    activeIcon: {
        css: css`
            color: #ffffff;
            font-family: "Roboto", sans-serif;
            font-size: .875rem;
            font-weight: bold;
        `,
    },
    menutriangle: {
        css: css`
            width: 0;
            height: 0;
            border: 15px solid transparent;
            border-bottom-color: #f3f4f5;
            top: 46%;
            right: 32%;
            z-index: 3;
            position: absolute;
        `,
    },
};

export const GlobalAccountMenu: React.FC<Props> = props => {
    const [buttonIcon, setButtonIcon] = useState(false);
    const styles = GlobalAccountMenuStyles;
    const [myAccountMapping, setMyAccountMapping] = useState(props.myAccountMapping);
    const [myAccountPageLink,setMyAccountPageLink] = useState(props.myAccountPageLink as PageLinkModelCustom);
    const [linkGroups, setLinkGroups] = useState(props.linkGroups);

    useEffect(() => {        
        setMyAccountPageLink(props.myAccountPageLink as PageLinkModelCustom);       
    }, [props]);
    const getlinkgroupIdentifier = (link: PageLinkModelCustom) => {
        let identifier = "";
        linkGroups.forEach((group: any) => {
            const title = link.title;
            if (myAccountMapping[group].indexOf(title) !== -1) {
                identifier = group;
                return identifier;
            }
        });
        return identifier;
    };

    const closeAccMenu = () => {
        props.setShow(false);
    }

    return (
        <>  
            <StyledWrapper {...styles.menutriangle}></StyledWrapper>
            <GridContainer {...styles.menuWrapper}>
                <GridItem width={3} {...styles.buttonMenuWrapper}>
                    <StyledWrapper {...styles.buttonMenuItems}>
                        <StyledWrapper {...styles.userGreeting}>
                            <Typography {...styles.hiGreeting}>{translate("Hi")}</Typography>
                            <Typography {...styles.firstName}>{props.firstName}</Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.redUnderline}></StyledWrapper>
                    </StyledWrapper>
                </GridItem>
                <GridItem width={9} {...styles.headerMenuWrapper}>
                    <GridContainer {...styles.headerMenuItems}>
                        {linkGroups?.map(groupName => (
                            <GridItem width={4} {...styles.menuItem}>
                                <Typography {...styles.titleMenuHeaderTypography}>{translate(groupName)}</Typography>
                                {getlinkgroupIdentifier(myAccountPageLink) === groupName && (
                                    <StyledWrapper key={myAccountPageLink?.id}>
                                        <Link href={myAccountPageLink?.url} onClick={() => closeAccMenu()}>
                                            <Typography {...styles.linkItem}>
                                                {myAccountPageLink && translate(myAccountPageLink?.title)}
                                            </Typography>
                                        </Link>
                                        <StyledWrapper {...styles.greyUnderline}></StyledWrapper>
                                    </StyledWrapper>
                                )}
                                {myAccountPageLink?.children?.map(
                                    link =>
                                        getlinkgroupIdentifier(link) === groupName && (
                                            <StyledWrapper key={link?.id}>
                                                <Link href={link?.url} onClick={() => closeAccMenu()}>
                                                    <Typography {...styles.linkItem}>
                                                        {translate(link?.title)}
                                                    </Typography>
                                                </Link>
                                                <StyledWrapper {...styles.greyUnderline}></StyledWrapper>
                                            </StyledWrapper>
                                        ),
                                )}
                            </GridItem>
                        ))}
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </>
    );
};
